import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "view1" }
const _hoisted_2 = { class: "view2 radius-view1 main-view" }
const _hoisted_3 = { class: "freightTemplateAdd1" }
const _hoisted_4 = {
  key: 1,
  class: "el-icon-plus avatar-uploader-icon"
}
const _hoisted_5 = {
  key: 1,
  class: "el-icon-plus avatar-uploader-icon"
}
const _hoisted_6 = { key: 0 }
const _hoisted_7 = {
  key: 1,
  class: "el-icon-plus avatar-uploader-icon"
}

export function render(_ctx, _cache) {
  const _component_el_page_header = _resolveComponent("el-page-header")
  const _component_el_alert = _resolveComponent("el-alert")
  const _component_mi_title = _resolveComponent("mi-title")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_upload = _resolveComponent("el-upload")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_form = _resolveComponent("el-form")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_page_header, {
        onBack: _ctx.back,
        title: "返回",
        content: "添加精灵",
        style: {"margin-bottom":"20px"}
      }, null, 8, ["onBack"]),
      _createVNode(_component_el_alert, {
        style: {"margin-bottom":"30px"},
        closable: false,
        title: "添加的精灵信息！",
        type: "warning"
      }),
      _createVNode(_component_el_form, {
        ref: "refForm",
        model: _ctx.ruleForm,
        rules: _ctx.rules,
        "label-width": "100px"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_mi_title, { text: "精灵信息" }),
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_el_form_item, {
              label: "精灵封面",
              prop: "img"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  class: "dl-avatar-uploader-min square",
                  action: _ctx.uploadUrl,
                  data: _ctx.uploadData,
                  "show-file-list": false,
                  "on-success": _ctx.handleUpImage,
                  "before-upload": _ctx.beforeImageUpload,
                  "list-type": "picture",
                  accept: "image/*"
                }, {
                  tip: _withCtx(() => _cache[4] || (_cache[4] = [
                    _createElementVNode("div", { class: "el-upload__tip" }, "只能上传图片,且单张图片大小不能超过50MB", -1)
                  ])),
                  default: _withCtx(() => [
                    (_ctx.ruleForm.img)
                      ? (_openBlock(), _createBlock(_component_el_image, {
                          key: 0,
                          src: _ctx.ruleForm.img,
                          class: "avatar"
                        }, null, 8, ["src"]))
                      : (_openBlock(), _createElementBlock("i", _hoisted_4))
                  ]),
                  _: 1
                }, 8, ["action", "data", "on-success", "before-upload"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "精灵模型",
              prop: "mode"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  class: "dl-avatar-uploader-min square",
                  action: _ctx.localhostUploadUrl,
                  data: _ctx.uploadData,
                  "show-file-list": false,
                  "on-success": _ctx.handleUpImage2,
                  "before-upload": _ctx.beforeImageUpload,
                  "list-type": "picture",
                  accept: "image/*"
                }, {
                  tip: _withCtx(() => _cache[5] || (_cache[5] = [
                    _createElementVNode("div", { class: "el-upload__tip" }, "只能上传图片,且单张图片大小不能超过50MB", -1)
                  ])),
                  default: _withCtx(() => [
                    (_ctx.ruleForm.mode)
                      ? (_openBlock(), _createBlock(_component_el_image, {
                          key: 0,
                          src: _ctx.ruleForm.mode,
                          class: "avatar"
                        }, null, 8, ["src"]))
                      : (_openBlock(), _createElementBlock("i", _hoisted_5))
                  ]),
                  _: 1
                }, 8, ["action", "data", "on-success", "before-upload"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "精灵语音",
              prop: "audio"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_upload, {
                  class: "dl-avatar-uploader-min square",
                  action: _ctx.uploadUrl,
                  data: _ctx.uploadData2,
                  "show-file-list": false,
                  "on-success": _ctx.handleUpImage3,
                  "before-upload": _ctx.beforeImageUpload2,
                  accept: "audio/*"
                }, {
                  tip: _withCtx(() => _cache[6] || (_cache[6] = [
                    _createElementVNode("div", { class: "el-upload__tip" }, "只能上传音乐文件,大小不能超过50MB", -1)
                  ])),
                  default: _withCtx(() => [
                    (_ctx.ruleForm.audio)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.ruleForm.audio), 1))
                      : (_openBlock(), _createElementBlock("i", _hoisted_7))
                  ]),
                  _: 1
                }, 8, ["action", "data", "on-success", "before-upload"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "精灵名称",
              prop: "name"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, { type: "flex" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      type: "text",
                      placeholder: "请输入精灵名称",
                      modelValue: _ctx.ruleForm.name,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => ((_ctx.ruleForm.name) = $event)),
                      style: {"width":"80%"}
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              label: "精灵简介",
              prop: "notes"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _ctx.ruleForm.notes,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => ((_ctx.ruleForm.notes) = $event)),
                  rows: 2,
                  type: "textarea",
                  placeholder: "请输入精灵简介"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createVNode(_component_el_form_item, { style: {"margin-top":"20px"} }, {
            default: _withCtx(() => [
              _createVNode(_component_el_button, {
                type: "primary",
                onClick: _cache[2] || (_cache[2] = $event => (_ctx.submitForm(_ctx.ruleForm)))
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode("立即添加")
                ])),
                _: 1
              }),
              _createVNode(_component_el_button, {
                onClick: _cache[3] || (_cache[3] = $event => (_ctx.resetForm('refForm')))
              }, {
                default: _withCtx(() => _cache[8] || (_cache[8] = [
                  _createTextVNode("重置")
                ])),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ])
  ]))
}